import { render, staticRenderFns } from "./MenuFontSizeDropdown.vue?vue&type=template&id=8a14c8ce&"
import script from "./MenuFontSizeDropdown.vue?vue&type=script&lang=ts&"
export * from "./MenuFontSizeDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./MenuFontSizeDropdown.vue?vue&type=style&index=0&id=8a14c8ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports